import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as GC from "../../../../common/common";
import { GetSelected } from "../../../../common/tableHandler/manipulateTable";

export default function standart() {}

export const FillTableCallBack = (
  result,
  page_number,
  settingsPage,
  columnList
) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      /**free format */

      $.each(result.data, function (index, data) {
        var circleType = "";
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var identification = data["identification"];
        var statusBudget =
          data.content["status-budget"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusDetailplanning =
          data.content["status-detailplanning"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusGlobaleplanning =
          data.content["status-globaleplanning"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        const tmp = data.content["status-statuslaatstechecknatuurbescherming"]
        const tmp2 = data.content["status-datumchecknatuurbescherming"] !== undefined?
            new Date(data.content["status-datumchecknatuurbescherming"]).toLocaleString('nl').slice(0, -3): ""

        const statusLaatsteCheckNatuurbescherming =
            tmp === "Conflict" ? '<div class="red-circle rounded-circle"><span class="tooltiptext">'+tmp2+'</span></div>':
                tmp === "Geen conflict"? '<div class="green-circle rounded-circle"><span class="tooltiptext">'+tmp2+'</span></div>'
                    : '<div class="white-circle rounded-circle"><span class="tooltiptext">Niet gecheckt</span></div>'
        var statusVerzonden =
          data.content["status-verzonden"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusWerkorder =
          data.content["status-werkorder"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusWerkplan =
          data.content["status-werkplan"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusUitvoering =
          data.content["status-uitvoering"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var planningIscorrectiefonderhoud =
          data.content["planning-iscorrectiefonderhoud"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        /**iconların bitişi */

        /**diğer alanların başlangıcı */
        var algemeenGisratio = data.content["algemeen-gisratio"];
        if (typeof algemeenGisratio === "undefined") {
          algemeenGisratio = "";
        }
        var status = data.status[0].status;
        if (typeof status === "undefined") {
          status = "";
        }
        var maatregelNaam = data.content["maatregel-naam"];
        if (typeof maatregelNaam === "undefined") {
          maatregelNaam = "";
        }
        var werkplanNaam = data.content["werkplan-naam"];
        if (typeof werkplanNaam === "undefined") {
          werkplanNaam = "";
        }
        var planningspatroonNaam = data.content["planningspatroon-naam"];
        if (typeof planningspatroonNaam === "undefined") {
          planningspatroonNaam = "";
        }
        var planningsperiodeNaam = data.content["planningsperiode-naam"];
        if (typeof planningsperiodeNaam === "undefined") {
          planningsperiodeNaam = "";
        }
        var budgetNaam = data.content["budget-naam"];
        if (typeof budgetNaam === "undefined") {
          budgetNaam = "";
        }
        var beheereenheidNaam = data.content["beheereenheid-naam"];
        if (typeof beheereenheidNaam === "undefined") {
          beheereenheidNaam = "";
        }
        var beheeractiviteitLaag = data.content["beheeractiviteit-laag"];
        if (typeof beheeractiviteitLaag === "undefined") {
          beheeractiviteitLaag = "";
        }
        var disciplineNaam = data.content["discipline-naam"];
        if (typeof disciplineNaam === "undefined") {
          disciplineNaam = "";
        }

        var statusTijdstipVerzonden = data["status-tijdstip_verzonden"];
        if (typeof statusTijdstipVerzonden === "undefined") {
          statusTijdstipVerzonden = "";
        } else statusTijdstipVerzonden = GC.FormatDate(statusTijdstipVerzonden, "date");

        var planningsperiodeStartdatum =
          data.content["planningsperiode-startdatum"];
        if (typeof planningsperiodeStartdatum === "undefined") {
          planningsperiodeStartdatum = "";
        } else planningsperiodeStartdatum = GC.FormatDate(planningsperiodeStartdatum, "date");

        // ----------------------------------------------------------------------------------
        var field1 = data.content["extrainformatie-tekst01w"];
        if (typeof field1 === "undefined") {
          field1 = "";
        }
        var field2 = data.content["extrainformatie-tekst02w"];
        if (typeof field2 === "undefined") {
          field2 = "";
        }
        var field3 = data.content["extrainformatie-tekst03w"];
        if (typeof field3 === "undefined") {
          field3 = "";
        }
        var field4 = data.content["extrainformatie-tekst04w"];
        if (typeof field4 === "undefined") {
          field4 = "";
        }
        var field5 = data.content["extrainformatie-tekst05w"];
        if (typeof field5 === "undefined") {
          field5 = "";
        }
        var field6 = data.content["extrainformatie-tekst06w"];
        if (typeof field6 === "undefined") {
          field6 = "";
        }
        var field7 = data.content["extrainformatie-tekst07w"];
        if (typeof field7 === "undefined") {
          field7 = "";
        }
        var field8 = data.content["extrainformatie-tekst08w"];
        if (typeof field8 === "undefined") {
          field8 = "";
        }
        var model = {
          identification: identification,
          statusBudget: statusBudget,
          statusDetailplanning: statusDetailplanning,
          statusGlobaleplanning: statusGlobaleplanning,
          statusLaatsteCheckNatuurbescherming: statusLaatsteCheckNatuurbescherming,
          statusVerzonden: statusVerzonden,
          statusWerkorder: statusWerkorder,
          statusWerkplan: statusWerkplan,
          algemeenGisratio: algemeenGisratio,
          status: status,
          maatregelNaam: maatregelNaam,
          werkplanNaam: werkplanNaam,
          planningspatroonNaam: planningspatroonNaam,
          planningsperiodeNaam: planningsperiodeNaam,
          budgetNaam: budgetNaam,
          beheereenheidNaam: beheereenheidNaam,
          beheeractiviteitLaag: beheeractiviteitLaag,
          disciplineNaam: disciplineNaam,
          statusTijdstipVerzonden: statusTijdstipVerzonden,
          planningsperiodeStartdatum: planningsperiodeStartdatum,
          globalPlanning: data.content["planning-globaleplanning"] || [],
          field1: field1,
          field2: field2,
          field3: field3,
          field4: field4,
          field5: field5,
          field6: field6,
          field7: field7,
          field8: field8,
        };

        var ExtraFieldColumnModel = {
          tekst01w: field1,
          tekst02w: field2,
          tekst03w: field3,
          tekst04w: field4,
          tekst05w: field5,
          tekst06w: field6,
          tekst07w: field7,
          tekst08w: field8,
        };

        var test = {
          checkbox: checkbox,
          active: circleType,
          status_detailplanning: statusDetailplanning,
          status_budget: statusBudget,
          status_laatste_check_natuurbescherming: statusLaatsteCheckNatuurbescherming,
          status_uitvoering: statusUitvoering,
          status_werkplan: statusWerkplan,
          planning_iscorrectiefonderhoud: planningIscorrectiefonderhoud,
          status_verzonden: statusVerzonden,
          "Gisratio Id": algemeenGisratio,
          Status: status,
          "Maatregel": maatregelNaam,
          "Werkplan": werkplanNaam,
          "Planningspatroon": planningspatroonNaam,
          "Planningsperiode": planningsperiodeNaam,
          "Budget": budgetNaam,
          "Beheereenheid": beheereenheidNaam,
          Laag: beheeractiviteitLaag,
          "Discipline": disciplineNaam,
          "Tijdstip verzonden": statusTijdstipVerzonden,
          "Startdatum Planningsperiode": planningsperiodeStartdatum,
        };

        var _columnList = [];
        for (let column in columnList.column_list) {
          for (let key in test) {
            if (
              columnList.column_list[column].toLowerCase() == key.toLowerCase()
            ) {
              _columnList.push(test[key]);
            }
          }
        }

        // -----------------------------------------
        // free format, extra column field control
        var _columnListExtraColumn = [];
        for (let column in settingsPage) {
          for (let key in ExtraFieldColumnModel) {
            if (!settingsPage[column].visible) {
              _columnListExtraColumn.push("");
              break;
            } else if (
              settingsPage[column].field_name.toLowerCase() ==
                key.toLowerCase() &&
              settingsPage[column].visible === true
            ) {
              _columnListExtraColumn.push(ExtraFieldColumnModel[key]);
              break;
            }
          }
        }

        window.$mm_schedule_Glist.push(model);
        var addId = oTable.fnAddData(
          [
            ..._columnList,
            ..._columnListExtraColumn,
            // field1,
            // field2,
            // field3,
            // field4,
            // field5,
            // field6,
            // field7,
            // field8,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }

  $("#total-rows").html(result.meta.total_found);
  window.$mm_schedule_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$mm_schedule_treeChangeStatus = true;
  window.$mm_schedule_scroll_change = true;
  window.$mm_schedule_gvv = 0;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-gisratio") {
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_plannigAlgemeenGisratio.push(data);
    });
  } else if (data.id === "status") {
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_plannigStatus.push(data);
    });
  } else if (data.id === "maatregel-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_maatregelNaam.push(data);
    });
  } else if (data.id === "werkplan-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_werkplanNaam.push(data);
    });
  } else if (data.id === "budget-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_budgetNaam.push(data);
    });
  } else if (data.id === "discipline-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_disciplineNaam.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-gisratio") {
    window.$mm_schedule_plannigAlgemeenGisratio.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_plannigAlgemeenGisratio.push(data);
    });
  } else if (searchId === "status") {
    window.$mm_schedule_plannigStatus.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_plannigStatus.push(data);
    });
  } else if (searchId === "maatregel-naam") {
    window.$mm_schedule_maatregelNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_maatregelNaam.push(data);
    });
  } else if (searchId === "werkplan-naam") {
    window.$mm_schedule_werkplanNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_werkplanNaam.push(data);
    });
  } else if (searchId === "planningspatroon-naam") {
    window.$mm_schedule_planningspatroonNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_planningspatroonNaam.push(data);
    });
  } else if (searchId === "planningsperiode-naam") {
    window.$mm_schedule_planningsperiodeNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_planningsperiodeNaam.push(data);
    });
  } else if (searchId === "budget-naam") {
    window.$mm_schedule_budgetNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_budgetNaam.push(data);
    });
  } else if (searchId === "beheereenheid-naam") {
    window.$mm_schedule_beheereenheidNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_beheereenheidNaam.push(data);
    });
  } else if (searchId === "beheeractiviteit-laag") {
    window.$mm_schedule_beheeractiviteitLaag.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_beheeractiviteitLaag.push(data);
    });
  } else if (searchId === "discipline-naam") {
    window.$mm_schedule_disciplineNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_disciplineNaam.push(data);
    });
  } else if (searchId === "status-tijdstip_verzonden") {
    window.$mm_schedule_statusTijdstipVerzonden.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_schedule_statusTijdstipVerzonden.push(data);
    });
  }
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];
  const myPopup = $("#myPopup");


  /* $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  }); */

  myPopup.html("");
  if(GetSelected().length > 0){
      $.each(window.$mm_schedule_actions, function (index, action) {
        if ($.inArray(action["id"], result) !== -1) {
          var anchor = $("<a></a>")
              .attr({ href: "javascript:void(0)", id: action["id"] })
              .addClass(action["class"] + " mm_schedule_action")
              .html(action["text"]);
          $("#myPopup").append(anchor);
        }
      });
    }
    
  /* $.each(window.$mm_schedule_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " mm_schedule_action")
        .html(action["text"]);
      myPopup.append(anchor);
    }
  }); */



  // Instert bukbeheer action if there is any selected value
  if (result.length > 0){
    var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: "plannig_natuurbeschermingscheck" })
        .addClass("nature-protection-ico mm_schedule_action")
        .html("Natuurbeschermingscheck");
    myPopup.append(anchor);

    var anchor2 = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: "bulk_update" })
        .addClass("mm_schedule_action")
        .html("Bulkbeheer");
    myPopup.append(anchor2);
/*
    var anchor3 = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: "plannig_toon_op_kaart" })
        .addClass("locate mm_schedule_action")
        .html("Toon op kaart");
    myPopup.append(anchor3);*/
  }

  var toonOpKaart = $("<a></a>")
    .attr({ role: "button", id: "plannig_toon_op_kaart" })
    .addClass("locate mm_schedule_action")
    .html("Toon op kaart");
  $("#myPopup").append(toonOpKaart);


  //** aktif olmayan actionlar burada listeleniyor. */
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });

  const popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export const WijzigStatusCallback = (result, elementId) => {
  $("#" + elementId).html("");
  $.each(
    result.data.input_data_definition.structure_definition.schema.properties
      .status.enum,
    function (index, row) {
      var btn = '<div class="custom-control custom-radio">';
      btn +=
        '<input type="radio" class="custom-control-input" name="wijzig-status"  id="' +
        row +
        '" value="' +
        row +
        '" />';
      btn +=
        '<label class="custom-control-label" for="' +
        row +
        '">' +
        row +
        "</label></div>";
      $("#" + elementId).append(btn);
    }
  );
};

export const WerkplanCallback = (result) => {
  $("#werkplan-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="werkplan"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#werkplan-grp").append(btn);
  });
};

export const BudgetCallback = (result) => {
  $("#budget-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="budget"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#budget-grp").append(btn);
  });
};

export const PlaatsDetailplanningCallback = (result) => {
  $("#uitvoerder-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="uitvoerder"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#uitvoerder-grp").append(btn);
  });
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    if (element.sTitle) {
      test_list.push(element.sTitle);
    }
  });

  var emptyTest = test_list.findIndex((x) => x === "");
  if (emptyTest === -1) {
    var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
    test_list[checkIndex] = "checkbox";

    var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
    test_list[statusIndex] = "active";

    var status_detailplanningIndex = test_list.findIndex((x) =>
      x.includes("status_detailplanning")
    );
    test_list[status_detailplanningIndex] = "status_detailplanning";
    var status_budgetIndex = test_list.findIndex((x) =>
      x.includes("status_budget")
    );
    test_list[status_budgetIndex] = "status_budget";
    const status_natuurbeschermingIndex = test_list.findIndex((x) =>
        x.includes("status_laatste_check_natuurbescherming")
    );
    test_list[status_natuurbeschermingIndex] = "status_laatste_check_natuurbescherming";
    var status_uitvoeringIndex = test_list.findIndex((x) =>
      x.includes("status_uitvoering")
    );
    test_list[status_uitvoeringIndex] = "status_uitvoering";
    var status_werkplanIndex = test_list.findIndex((x) =>
      x.includes("status_werkplan")
    );
    test_list[status_werkplanIndex] = "status_werkplan";
    var planning_iscorrectiefonderhoudIndex = test_list.findIndex((x) =>
      x.includes("planning_iscorrectiefonderhoud")
    );
    test_list[planning_iscorrectiefonderhoudIndex] =
      "planning_iscorrectiefonderhoud";
    var status_verzondenIndex = test_list.findIndex((x) =>
      x.includes("status_verzonden")
    );
    test_list[status_verzondenIndex] = "status_verzonden";

    var model = {
      identification: identification,
      code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
      client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
      reference: columnOrderReference,
      data: {
        table_sorting: [
          {
            name: "management-maintenance>schedule",
            column_list: [],
          },
        ],
      },
    };
    var asd = (model.data.table_sorting.find(
      (x) => x.name === "management-maintenance>schedule"
    ).column_list = test_list);
    omnimap.GetFreeFormatAction(identification, "PUT", model);

    return model.data.table_sorting[0];
  }
}
